import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["mode", "nightlyPrice", "monthlyPrice", "weeklyDiscount", "monthlyDiscount", "minNights"]

  connect() {
    this.update()
  }

  update() {
    const mode = this.selectedMode()

    this.toggle(this.nightlyPriceTargets, mode !== "monthly_only")
    this.toggle(this.monthlyPriceTargets, mode !== "nightly_only")
    this.toggle(this.weeklyDiscountTargets, mode !== "monthly_only")
    this.toggle(this.monthlyDiscountTargets, mode === "nightly_only")

    this.minNightsTargets.forEach(input => {
      input.min = mode === "monthly_only" ? 30 : 1
      if (mode === "monthly_only" && Number(input.value) < 30) input.value = 30
    })
  }

  selectedMode() {
    const checked = this.modeTargets.find(input => input.checked)
    return checked ? checked.value : "nightly_only"
  }

  toggle(elements, visible) {
    elements.forEach(element => element.classList.toggle("hidden", !visible))
  }
}
